import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import NewMemberCard from './NewMemberCard';
import { fetchMembersNewest } from '@general/api/memberAPI';
import { mapAPIMemberToProps } from '@general/transforms/member.transform';

const ResultsContainerStyled = styled.div`
    display: flex;
    flex-wrap: wrap;

    @media (min-width: 1200px) {
        margin: 32px -12px 0 -12px;
    }
`;

const CardContainerStyled = styled.div`
    width: 100%;

    @media (min-width: 1200px) {
        margin: 0 12px;

        &.one-per-row {
            flex: 0 0 100%;
            max-width: calc(100% - 24px);
        }

        &.two-per-row {
            flex: 0 0 50%;
            max-width: calc(50% - 24px);
        }

        &.three-per-row {
            flex: 0 0 33.33333%;
            max-width: calc(33.33333% - 24px);
        }
    }
`;

const NewMembers = () => {
    const [members, setMembers] = useState();

    useEffect(() => {
        (async () => {
            const {
                data: { data },
            } = await fetchMembersNewest();

            setMembers(data);
        })();
    }, []);

    if (!members) {
        return null;
    }

    return (
        <div className="container-fluid bg-gray-lightest py-4 pt-md-6 featured-events m18a">
            <div className="container">
                <div className="d-flex justify-content-start m-0 p-0">
                    <span className="display7 secondary mr-auto">New members</span>
                    <span className="display7 m-0 p-0 text-right">
                        <a href="/search?type=members&sort=sort_by_created_at" className="view-all accent">
                            View all
                        </a>
                    </span>
                </div>

                <ResultsContainerStyled>
                    {members.map(member => (
                        <CardContainerStyled key={member.id} className="d-flex flex-column mb-1.5rem three-per-row">
                            <NewMemberCard {...mapAPIMemberToProps({ member })} />
                        </CardContainerStyled>
                    ))}
                </ResultsContainerStyled>
            </div>
        </div>
    );
};

export default NewMembers;
